import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getCacheHashes(payload) {
	return dataTransferWrap(ModulesMap.CACHE, dtConfig[ModulesMap.CACHE].getHashes, payload)
}

export default {
	getCacheHashes,
}
